module.exports = __webpack_public_path__ + "img/20m6.91bf5221.jpg";